<template>
  <router-view></router-view>
</template>

<style lang="less">
.el-card {
  --el-card-padding: 10px !important;
}
</style>
